import CopyToClipboard from './copy-to-clipboard';

export default CopyToClipboard;
export type * from './types';
